"use strict";

exports.__esModule = true;
exports.crosshairPropTypes = exports.crosshairTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
const crosshairTypes = ['x', 'y', 'top-left', 'top', 'top-right', 'right', 'bottom-right', 'bottom', 'bottom-left', 'left', 'cross'];
exports.crosshairTypes = crosshairTypes;
const crosshairPropTypes = {
  type: _propTypes.default.oneOf(crosshairTypes)
};
exports.crosshairPropTypes = crosshairPropTypes;